import React, { useState } from "react";
import cn from "classnames";
import styles from "./Share.module.sass";
import Icon from "../Icon";
import OutsideClickHandler from "react-outside-click-handler";

const Share = ({ className, openUp, darkButton, url, title, description }) => {
  // URL de production Edutio
  const PRODUCTION_URL = "https://edutio.fr";
  
  // Utiliser l'URL fournie ou construire l'URL de production
  const getShareUrl = () => {
    if (url) return url;
    // En local, utiliser l'URL de production avec le pathname actuel
    if (window.location.hostname === "localhost") {
      return `${PRODUCTION_URL}${window.location.pathname}`;
    }
    return window.location.href;
  };
  
  const shareUrl = getShareUrl();
  const [visible, setVisible] = useState(false);

  // Fonction pour créer l'URL de partage LinkedIn
  const getLinkedInShareUrl = () => {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
  };
  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div
        className={cn(
          className,
          styles.share,
          { [styles.openUp]: openUp },
          { [styles.darkButton]: darkButton }
        )}
      >
        <button
          className={cn(
            "button-circle-stroke button-small",
            { [styles.active]: visible },
            styles.button
          )}
          onClick={() => setVisible(!visible)}
        >
          <Icon name="download" size="22" />
        </button>
        <div className={cn(styles.body, { [styles.show]: visible })}>
          <div className={styles.title}>Partager</div>
          <div className={styles.list}>
            <a 
              href={getLinkedInShareUrl()} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.link}
              title="Partager sur LinkedIn"
            >
              <span>
                <Icon name="linkedin" size="20" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Share;
